// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"55a778bb","239":"0b71a084","455":"1676a831"}[chunkId] + ".chunk.js";
};